import { Schema } from "@generation/core";
import { IPageFlowStep } from "@shared/shared-generic-rekenmodule";
/**
 * Returns an array of pageflowsteps based on the linked list of the first step.
 * The summary / last step can be excluded.
 * @param firstStep The first step in the linked list
 * @returns All page flow steps
 */
export function getAllPageFlowSteps(firstStep: IPageFlowStep): IPageFlowStep[] {
  const allFlowSteps: IPageFlowStep[] = [];
  let currentStep: IPageFlowStep | undefined = firstStep;
  while (currentStep) {
    allFlowSteps.push(currentStep);
    currentStep = currentStep.nextFlowStep;
  }
  return allFlowSteps;
}

export function getSchemas(pageflowSteps: IPageFlowStep[], variables: any, includeReadOnly: boolean = false, includeResultStep: boolean = false): Schema[] {
  let schemas: Schema[] = [];
  pageflowSteps.forEach((pageflowStep) => {
    if((!pageflowStep.isReadOnly || includeReadOnly) 
        && (!pageflowStep.isResultStep || includeResultStep)) {
        schemas.push(pageflowStep.getSchema(variables)());
    }
  });
  return schemas;
}
